/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntrustSignatureStatusResponseDto } from '../../models/entrust-signature-status-response-dto';

export interface SkipSignature$Params {
  processId: string;
}

export function skipSignature(http: HttpClient, rootUrl: string, params: SkipSignature$Params, context?: HttpContext): Observable<StrictHttpResponse<EntrustSignatureStatusResponseDto>> {
  const rb = new RequestBuilder(rootUrl, skipSignature.PATH, 'post');
  if (params) {
    rb.path('processId', params.processId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EntrustSignatureStatusResponseDto>;
    })
  );
}

skipSignature.PATH = '/kyc/processes/{processId}/signature/skip';
